import { z } from 'zod';
import { InspectionRequestTimeSlotMeridiemSchema } from '../inputTypeSchemas/InspectionRequestTimeSlotMeridiemSchema'

/////////////////////////////////////////
// INSPECTION REQUEST TIME SLOT SCHEMA
/////////////////////////////////////////

export const InspectionRequestTimeSlotSchema = z.object({
  meridiem: InspectionRequestTimeSlotMeridiemSchema.nullable(),
  id: z.bigint(),
  inspection_id: z.bigint(),
  city_id: z.number().int(),
  preferred_date: z.coerce.date(),
  priority: z.number().int(),
})

export type InspectionRequestTimeSlot = z.infer<typeof InspectionRequestTimeSlotSchema>

export default InspectionRequestTimeSlotSchema;
